export const editor = {
	editorComponentContainer: '.js-editor-component',
	editorComponentChangeHandler: 'data-change-handler',
	editorComponentInitialValue: 'data-initial-value',
	editorSaveButton: '.js-editor-save',
	editorError: '.js-editor-error-placeholder',
}
